import axios from 'axios'
import { UNIT_KEY, IMPERIAL, METRIC, unitPreference } from 'helpers/globals'
import notifyHoneybadger from 'helpers/notifyHoneybadger'
import localStorage from 'helpers/localStorage'

export default _ => {
  axios.get(`${IPVM_URL}/${unitPreference}`).then(res => {
    localStorage.setItem(UNIT_KEY, res.data.prefers_metric ? METRIC : IMPERIAL)
  }).catch(err => {
    notifyHoneybadger({ err, action: { type: 'LOCATING_USER_FOR_UNIT_OF_MEASUREMENT_DEFAULT' } })
  })
}



// WEBPACK FOOTER //
// ./src/helpers/setUnitInLocalStorage.js